import React from 'react';
// import MemberOnly from 'components/Promotions/InnerPage/MemberOnly';
// import ActivityInfo from 'components/Promotions/InnerPage/ActivityInfo';
// import WinningAnnouncement from 'components/Promotions/InnerPage/WinningAnnouncement';
// import Schemes from 'components/Promotions/InnerPage/Schemes';
// import ActivityNotes from 'components/Promotions/InnerPage/ActivityNotes';
// import PageNavControls from 'components/PageNavControls';

const PromotionsInnerPageA: React.FC = () => (
  <div className="promotions-inner-page promotions-inner-page-a">
    {
      /**
       *
    <MemberOnly>
    <MemberOnly.Head />
    <MemberOnly.InnerPageAAds />
  </MemberOnly>

  <ActivityInfo />

  <WinningAnnouncement />

    <Schemes.InnerPageASchemes />
  </Schemes>

  <ActivityNotes />

  <PageNavControls
    prevBtnLink="/"
    nextBtnLink="/"
    navBtnLink="/"
    navBtnText="回活動頁"
  />
      */
    }
  </div>
);

export default PromotionsInnerPageA;
